<div class="p-md-4 p-3">
  <header class="pb-md-3">
    <a *ngIf="showCloseButton" class="popupclose" href="javascript:void(0)" [id]="closeButtonId" [name]="closeButtonName" (click)="onCloseClick()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#464E58"/>
      </svg>
    </a>
    <span class="text-uppercase smlgxt text-blue">{{headerLabel}}</span>
    <h2 class="popup-caption callbackbold position-relative align-items-start">{{title}}</h2>
  </header>
  
  <div class="box">
    <div *ngIf="errorMsg" class="alert alert-danger mb-0" role="alert">
      {{errorMsg}}
    </div>
    <div *ngIf="successMsg" class="alert alert-success mb-0" role="alert">
      {{successMsg}}
    </div>
    <div *ngIf="showPrompt">{{promptText}}</div>
  </div>
  
  <footer class="boxfooter mt-3" *ngIf="showFooter">
    <div>
      <button type="button" class="btnblue py-2 px-4 mb-3"
        [id]="yesButtonId"
        [name]="yesButtonName"
        (click)="onYesClick()">{{yesButtonLabel}}</button>
    </div>
    <div *ngIf="showNoButton">
      <button type="button" class="btnline px-4 py-2"
        [id]="noButtonId"
        [name]="noButtonName"
        (click)="onNoClick()">{{noButtonLabel}}</button>
    </div>
  </footer>
</div>
